import { Container, Nav } from "react-bootstrap";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { NavigationGuardProvider, useNavigationGuard } from "../NavigationGuardContext";

function TabNav({ tabs }) {
  const navigate = useNavigate();
  const location = useLocation();
  const guardRef = useNavigationGuard();

  const handleTabClick = async (e, tab) => {
    e.preventDefault();
    const isActive = tab.end
      ? location.pathname === tab.to
      : location.pathname === tab.to || location.pathname.startsWith(tab.to + "/");
    if (isActive) return;

    if (guardRef?.current) {
      const canProceed = await guardRef.current();
      if (!canProceed) return;
    }
    navigate(tab.to);
  };

  return (
    <Nav variant="tabs" className="mb-3">
      {tabs.map((tab) => {
        const isActive = tab.end
          ? location.pathname === tab.to
          : location.pathname === tab.to || location.pathname.startsWith(tab.to + "/");
        return (
          <Nav.Item key={tab.key}>
            <Nav.Link
              href={tab.to}
              active={isActive}
              onClick={(e) => handleTabClick(e, tab)}
            >
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  );
}

export default function ClientEditLayout() {
  const { id } = useParams();

  const tabs = [
    { key: "demographics",  label: "Demographics",   to: `/clients/${id}`,               end: true  },
    { key: "employment",    label: "Employment",      to: `/clients/${id}/employment`,    end: false },
    { key: "financials",    label: "Financials",      to: `/clients/${id}/financials`,    end: false },
    { key: "health",        label: "Health",          to: `/clients/${id}/health`,        end: false },
    { key: "intakeSummary", label: "Intake Summary",  to: `/clients/${id}/intake-summary`,end: false },
  ];

  return (
    <NavigationGuardProvider>
      <Container fluid className="p-3">
        <TabNav tabs={tabs} />
        <Outlet />
      </Container>
    </NavigationGuardProvider>
  );
}
